import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { BaseButton } from '@7f-ui/components/button/button';
import { useResizeObserverRef } from '@7f-ui/hooks/use-resize-observer-ref';
import { useRef, useState } from 'react';
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation';
import { AccommodationReviewHeader, AccommodationReviewTexts } from './review-content';
type AccommodationReviewCardsProps = {
  reviews: AccommodationFragment['reviews'];
  onReadMore: (id: string) => void;
};
export function AccommodationReviewCards(t0) {
  const $ = _c(7);
  const {
    reviews,
    onReadMore
  } = t0;
  let t1;
  if ($[0] !== onReadMore || $[1] !== reviews) {
    let t2;
    if ($[3] !== onReadMore) {
      t2 = review => <AccommodationReviewCard key={review.id} review={review} onReadMore={onReadMore} />;
      $[3] = onReadMore;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = reviews.map(t2);
    $[0] = onReadMore;
    $[1] = reviews;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="flex flex-col gap-4">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
type AccommodationReviewCardProps = {
  review: AccommodationFragment['reviews'][number];
  onReadMore: (id: string) => void;
};
function AccommodationReviewCard(t0) {
  const $ = _c(13);
  const {
    review,
    onReadMore
  } = t0;
  const [textOverflow, setTextOverflow] = useState(false);
  const buttonHeight = useRef(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const [entry] = t2;
      if (buttonHeight.current === entry.contentRect.height) {
        return;
      }
      setTextOverflow(entry.target.scrollHeight > 176);
      buttonHeight.current = entry.contentRect.height;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [buttonRef] = useResizeObserverRef(t1);
  let t2;
  if ($[1] !== onReadMore || $[2] !== review.id) {
    t2 = () => onReadMore(review.id);
    $[1] = onReadMore;
    $[2] = review.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== textOverflow) {
    t3 = cx("relative max-h-44 w-full overflow-hidden rounded-lg border border-primary/15 text-left hover:border-primary/30", {
      "after:absolute after:inset-x-0 after:bottom-0 after:h-24 after:bg-linear-to-t after:from-15% after:from-white": textOverflow
    });
    $[4] = textOverflow;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== review) {
    t4 = <div className="m-4 flex flex-col gap-4"><AccommodationReviewHeader review={review} /><AccommodationReviewTexts review={review} /></div>;
    $[6] = review;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== buttonRef || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <li><BaseButton ref={buttonRef} onClick={t2} className={t3}>{t4}</BaseButton></li>;
    $[8] = buttonRef;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}